// TODO: merge into one get browser utility
export const isFirefox = (): boolean => navigator.userAgent.includes('Firefox')
